module.exports = __webpack_public_path__ + "img/SAP_8693_l.61dec4ed.jpg";